// Enums y tipos relacionados con usuarios

/**
 * Motivos de desactivación de un usuario
 */
export enum MotivoDesactivacion {
  /** Cliente solicita baja del servicio */
  BAJA = 'BAJA',
  
  /** Cliente ya no tiene más clases programadas (desactivación automática) */
  NO_MAS_CLASE = 'NO_MAS_CLASE',
  
  /** Error durante el proceso de creación del usuario */
  ERROR_CREACION = 'ERROR_CREACION',
}

/**
 * Registro del histórico de cambios de estado de un usuario
 */
export interface UsuarioEstadoLog {
  id: number;
  usuarioId: number;
  activo: boolean;
  deactivationReason?: MotivoDesactivacion | null;
  actorId?: number | null;
  createdAt: string;
}

export interface Usuario {
  id: number;
  nombre: string;
  apellidos: string;
  email: string;
  telefono?: string;
  rol: string;
  activo: boolean;
  createdAt: string;
  updatedAt: string;
}
